module.exports = __webpack_public_path__ + "static/portfolio-mas-7-58d254159ec2e92a675712490702ca80.jpg";